import { render } from "./StatisticVariant.vue?vue&type=template&id=7f9acc1a&scoped=true"
import script from "./StatisticVariant.vue?vue&type=script&lang=js"
export * from "./StatisticVariant.vue?vue&type=script&lang=js"

import "./StatisticVariant.vue?vue&type=style&index=0&id=7f9acc1a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9acc1a"]])

export default __exports__